<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-card flat>
        <v-card-title>
            <v-icon color="green" left>
                info
            </v-icon>
            <span class="title font-weight-regular">Συγγράμματα από Εξαργύρωση</span>
        </v-card-title>

        <v-divider inset></v-divider>
        <v-list subheader v-if="$store.getters.booksFromRedeemByDistPoint.length > 0">
            <v-subheader inset v-if="!$store.getters.studentAddressInformation">Παραλαβή από Σημεία Διανομής</v-subheader>

            <v-expansion-panel>
                <v-expansion-panel-content
                        :hide-actions="$store.getters.studentAddressInformation"
                        :key="i"
                        v-for="(item,i) in $store.getters.booksFromRedeemByDistPoint">
                    <template slot="header">
                        <v-list-tile avatar @click="">
                            <v-list-tile-avatar size="36px">
                                <v-icon class="primary white--text" small>library_books</v-icon>
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <v-list-tile-title class="text-truncate">
                                    <a @click.stop="openDialog(item.book.books.books[0].book)">
                                        {{item.book.books.books[0].book.title}}</a>
                                </v-list-tile-title>
                                <v-list-tile-sub-title>{{item.book.books.books[0].book.id}} - ISBN:
                                    {{item.book.books.books[0].book.isbn}}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <div class="red--text caption" v-if="!$store.getters.studentAddressInformation">Επιλέξτε εδώ</div>
                            <v-list-tile-action>
                                <ToolTipComponent  :bookId="item.book.books.books[0].book.id"/>
                            </v-list-tile-action>
                        </v-list-tile>
                    </template>
                    <v-card v-if="!$store.getters.studentAddressInformation">
                        <v-card-text>
                            <ExchangeTypeComponent  v-if="$store.getters.newStatementAllow || $store.getters.exchangeTypeComponentFlag"
                                    :book="item.book.books.books[0].book"
                                                    :key="item.book.books.books[0].book.id"
                                                   :statementBookGroupType="item.book.books.books.statementBookGroupType"/>

                            <v-divider></v-divider>
                            <v-card>

                                <DistributionPointComponent :key="i"
                                                            :booksFromCheckedOrRedeemByDistPoint = "$store.getters.booksFromRedeemByDistPoint"
                                                            :book="item.book.books.books[0].book"
                                                            :point="point" class="mx-5"
                                                            v-for="(point,i) in item.points"/>
                            </v-card>

                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-list>

        <v-list subheader v-if="$store.getters.booksFromRedeemByCourrier.length > 0">
            <v-subheader inset v-if="!$store.getters.studentAddressInformation">Παραλαβή από Courier</v-subheader>

            <v-expansion-panel>
                <v-expansion-panel-content
                        :hide-actions="$store.getters.studentAddressInformation"
                        :key="i"
                        v-for="(item,i) in $store.getters.booksFromRedeemByCourrier">
                    <template slot="header">
                        <v-list-tile avatar>
                            <v-list-tile-avatar size="36px">
                                <v-icon class="primary white--text" small>library_books</v-icon>
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <v-list-tile-title>
                                    <a @click.stop="openDialog(item.book.books.books[0].book)">
                                        {{item.book.books.books[0].book.title}}</a>
                                </v-list-tile-title>
                                <v-list-tile-sub-title>{{item.book.books.books[0].book.id}} - ISBN:
                                    {{item.book.books.books[0].book.isbn}}</v-list-tile-sub-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <ToolTipComponent  :bookId="item.book.books.books[0].book.id"/>
                            </v-list-tile-action>
                        </v-list-tile>
                    </template>
                    <v-card v-if="!$store.getters.studentAddressInformation">
                        <v-card-text>

                            <ExchangeTypeComponent  v-if="$store.getters.newStatementAllow || $store.getters.exchangeTypeComponentFlag"
                                    :book="item.book.books.books[0].book"
                                                    :key="item.book.books.books[0].book.id"
                                                   :statementBookGroupType="item.book.books.books.statementBookGroupType"/>
                            <v-layout v-if="item !== undefined && item != null && item.book.books.books[0].book.hasOwnProperty('status')" align-center justify-start mb-3>

                                <div  class="ml-5">
                                    <v-chip class="px-2 py-2">
                                        <v-icon class="mr-2">local_shipping</v-icon>
                                        <i v-html="util.returnStatementBookCourrierStatusText(item.book.books.books[0].book)"></i>
                                    </v-chip>

                                </div>

                            </v-layout>

                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-list>

    </v-card>
</template>

<script>
    import util from "../../utilities";
    import ExchangeTypeComponent from "../ExtraComponents/ExchangeTypeComponent";
    import DistributionPointComponent from "../ExtraComponents/DistributionPoinComponent";
    import ToolTipComponent from "../ExtraComponents/ToolTipComponent";

    export default {
        name: "FinalSubmitRedeemComponent",
        components: {ExchangeTypeComponent, DistributionPointComponent, ToolTipComponent},
        data() {
            return {
                util
            }
        },
        methods:{
            openDialog(book) {
                this.$store.commit('setBookInfoModal', book);
                this.$store.commit('setDialog', true)
            }
        }
    }
</script>

<style scoped>

</style>